import { createAction } from 'redux-actions';

const SELECT_BANK = 'SELECT_BANK';

export default function bankSelection(
  state = {
    selectedBank: null,
  },
  { payload, type }
) {
  switch (type) {
    case SELECT_BANK: {
      const { selectedBank } = payload;
      return {
        ...state,
        selectedBank,
      };
    }
    case 'RESET_TRANSACTION': {
      return {
        ...state,
        selectedBank: null,
      };
    }
    default:
      return state;
  }
}

export function selectBank(selectedBank) {
  return createAction(SELECT_BANK)({ selectedBank });
}
